import React, { useRef } from "react";
import ReactSelect from "react-select";

export const MultiSelect = ({
  value,
  options,
  onChange,
  allLabel = "Todos",
  ...props
}) => {
  // isOptionSelected sees previous value after onChange

  const valueRef = useRef(value);
  valueRef.current = value;

  const selectAllOption = {
    value: "<SELECT_ALL>",
    label: allLabel,
  };

  const isSelectAllSelected = () => {
    if (!valueRef.current.length) {
      return false;
    }
    return valueRef.current.length === options.length;
  };

  const isOptionSelected = (option) => {
    return (
      valueRef.current.some(({ value }) => value === option.value) ||
      isSelectAllSelected()
    );
  };

  const getOptions = () => [selectAllOption, ...options];

  const getValue = () => {
    return isSelectAllSelected() ? [selectAllOption] : value;
  };

  const handleChange = (newValue, actionMeta) => {
    const { action, option, removedValue } = actionMeta;

    if (action === "select-option" && option.value === selectAllOption.value) {
      onChange(options, actionMeta);
    } else if (
      (action === "deselect-option" &&
        option.value === selectAllOption.value) ||
      (action === "remove-value" &&
        removedValue.value === selectAllOption.value)
    ) {
      onChange([], actionMeta);
    } else if (
      actionMeta.action === "deselect-option" &&
      isSelectAllSelected()
    ) {
      onChange(
        options.filter(({ value }) => value !== option.value),
        actionMeta
      );
    } else {
      onChange(newValue || [], actionMeta);
    }
  };

  return (
    <ReactSelect
      isOptionSelected={isOptionSelected}
      options={getOptions()}
      value={getValue()}
      onChange={handleChange}
      hideSelectedOptions={false}
      closeMenuOnSelect={false}
      isMulti
      {...props}
    />
  );
};
